/**
 * PageLoader - full-screen loading state with pulsing brand logo
 *
 * @param message - label shown below the logo (default: "Loading…")
 */

import { TrafficLightLogo } from '@/components/TrafficLightLogo';

interface PageLoaderProps {
  message?: string;
}

export function PageLoader({ message = 'Loading\u2026' }: PageLoaderProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[rgb(5,5,5)]">
      <div className="text-center flex flex-col items-center">
        <div className="animate-pulse mb-4">
          <TrafficLightLogo size="lg" showSub />
        </div>
        <p className="text-zinc-400">{message}</p>
      </div>
    </div>
  );
}
